<div class="relative min-w-56 flex-1">
  <guarantees-search-field
    name="icd10"
    [filled]="!!display()"
    [placeholder]="display() || ('guaranteeV2.message.searchIcd10' | translate)"
    [value]="term()"
    [loading]="searching()"
    (valueChange)="search($event)"
    (opened)="open.set(true)"
    (closed)="open.set(false)"
  ></guarantees-search-field>

  @if (open() && term().trim().length > 0) {
    <guarantees-option-list
      inline
      [empty]="results().length === 0"
      [emptyMessage]="'guaranteeV2.message.noIcd10Results' | translate"
      [loading]="searching()"
      [loadingMessage]="'guaranteeV2.message.searchingIcd10' | translate"
    >
      @for (item of results(); track item.id) {
        @let taken = isTaken(item.code);

        <li>
          <button
            guaranteesOption
            type="button"
            class="disabled:cursor-not-allowed disabled:bg-neutral-50 disabled:hover:bg-neutral-50"
            [disabled]="taken"
            (click)="choose(item)"
          >
            <span
              class="shrink-0 font-mono font-semibold"
              [class]="taken ? 'text-neutral-400' : 'text-neutral-700'"
              >{{ item.code }}</span
            >
            <span
              class="min-w-0 flex-1 truncate"
              [class]="taken ? 'text-neutral-400' : 'text-neutral-600'"
              >{{ item.nameUa || item.nameEn }}</span
            >

            <!-- Says why the row will not answer, where a greyed row alone would read as broken. -->
            @if (taken) {
              <span class="inline-flex shrink-0 items-center gap-0.5 rounded-full bg-neutral-100 px-1.5 text-xs font-semibold text-neutral-500">
                <mat-icon class="h-3! w-3! shrink-0 text-xs! leading-3!">check</mat-icon>
                {{ "guaranteeV2.message.diagnosisAlreadyAdded" | translate }}
              </span>
            }

            <!-- Depth in the ICD-10 tree: a chapter is a coarser pick than a leaf. -->
            @if (item.level) {
              <span
                class="shrink-0 text-neutral-300 tabular-nums"
                [matTooltip]="'guaranteeV2.message.icd10LevelHint' | translate: { level: item.level }"
                >L{{ item.level }}</span
              >
            }
          </button>
        </li>
      }
    </guarantees-option-list>
  }
</div>
